import isNil from "lodash/isNil";
import { ScoreValueCell } from "PFApp/activities/show/activity_page/parts/tabs/components/table_cells";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { MatchScoresSnakeCase } from "PFCore/types";
import { useTranslation } from "react-i18next";

import css from "./match_value.module.scss";

type MatchValueTooltippedProps = {
  scores: MatchScoresSnakeCase | null | undefined;
  scoreName: string;
};

const MatchValueTooltipped = ({ scores, scoreName }: MatchValueTooltippedProps) => {
  const { t } = useTranslation();
  const scoreValue = scores?.[scoreName];
  const translatedScoreName = t(`table.tooltips.matchScore.${scoreName}` as unknown as TemplateStringsArray);

  if (!isNil(scoreValue)) {
    return <ScoreValueCell score={scoreValue} />;
  }

  return (
    <Tooltip
      content={
        <Typography variant="bodyRegular">
          {t("table.tooltips.matchScore.noScore", { scoreName: translatedScoreName })}
        </Typography>
      }
      triggerContainerProps={{ className: css.tooltipTriggerContainer }}
    >
      <Typography variant="bodyRegular">-</Typography>
    </Tooltip>
  );
};

export default MatchValueTooltipped;
